import { render } from "./forgot.vue?vue&type=template&id=49cf1606"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"

import "./forgot.vue?vue&type=style&index=0&id=49cf1606&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\ru-online-education\\online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__